import React, { useEffect, useState, useContext } from "react";
import styles from "./FiltersComponents.module.css";
import { GlobalStateContext } from "../../context/GlobalStateContext";

import { FilterDropdown } from "./FilterDropdown";

function FiltersComponent() {
  const { filteredCompanies, filters, companiesData } = useContext(GlobalStateContext);
  
  const [companyNames, setCompanyNames] = useState([]);
  const [companyCountries, setCompanyCountries] = useState([]);
  const [sectors, setSectors] = useState([]);

  useEffect(() => {
    const {companyNames, companyCountries, sectors} = companiesData.reduce((acc, company) => {
      if (filters.sectors.length < 1 || filters.sectors.includes(company.sector)) {
        acc.companyNames.add(company.companyName);
      }
      
      acc.companyCountries.add(company.companysCountry);
      acc.sectors.add(company.sector);
      
      return acc;
    }, {
      companyCountries: new Set(),
      companyNames: new Set(),
      sectors: new Set(),
    });
    
    setCompanyNames(Array.from(companyNames));
    setCompanyCountries(Array.from(companyCountries));
    setSectors(Array.from(sectors));
    
  }, [companiesData, filters]);

  return (
    <>
      <div className={styles.filtersContainer}>
        <FilterDropdown 
          single_item="company"
          plural_items="companies"
          options={companyNames}
          filterType="companyNames"
        />
        <FilterDropdown 
          single_item="sector"
          plural_items="sectors"
          options={sectors}
          filterType="sectors"
        />
        {/* <FilterDropdown 
          single_item="country"
          plural_items="countries"
          options={companyCountries}
          filterType="companyCountries"
        /> */}
      </div>
    </>
  );
}

export default FiltersComponent;
